<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-list-ol"></i> Levels
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()" tooltip="Add level" placement="top">
              <i class="fa fa-plus"></i> Add Level
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Level ID</th>
                <th>Level</th>
                <th>XP Required</th>
                <th>Reward</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (level of levels; track level.levelId; let i = $index) {
                <tr>
                  <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                  <td>{{ level.levelId }}</td>
                  <td>{{ level.level }}</td>
                  <td>{{ level.nextLevelExperienceRequired }}</td>
                  <td>{{ level.nextLevelReward }}</td>
                  <td>
                    <div class="btn-group me-1">
                      <button class="btn btn-sm btn-warning" type="button" (click)="onClickEdit(level)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                    </div>
                    |
                    <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(level)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + levels.length }} of {{ totalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="pageNumber <= 1">
                <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === pageNumber">
                    <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="levels.length < resultsPerPage">
                <button class="page-link" (click)="onClickPaginationNext()" [disabled]="levels.length < resultsPerPage">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-level-add-modal #addModal></app-level-add-modal>
<app-level-edit-modal #editModal></app-level-edit-modal>
